<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-public-kanban`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 7h38a2 2 0 012 2v30a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2zm2 4v26h34V11H7zm7 12h3a1 1 0 011 1v7a1 1 0 01-1 1h-3a1 1 0 01-1-1v-7a1 1 0 011-1zm17-2h3a1 1 0 011 1v9a1 1 0 01-1 1h-3a1 1 0 01-1-1v-9a1 1 0 011-1zm-8.5-4h3a1 1 0 011 1v13a1 1 0 01-1 1h-3a1 1 0 01-1-1V18a1 1 0 011-1z"/></svg>
</template>
<script>

export default {
  name: 'IconPublicKanban',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
